import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const CoachmarkArrowIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 50;
  const color = props.color || 'white';
  return <Icon name={'coachmark-arrow'} size={size} color={color} />;
};

export default React.memo(CoachmarkArrowIcon);
